export default __webpack_public_path__ + "static/media/pantry1-afterF-1440w.8950013e.webp";